import * as Yup from 'yup';
import { Moment } from 'moment';
import moment from 'moment';

export interface ManualBillingFormValues {
  Details: string;
  Amount: string;
  Card: string;
  BillingDate: Moment | null;
}

export const manualBillingValidationSchema = Yup.object().shape({
  Details: Yup.string().required('Details is required'),
  Amount: Yup.string()
    .required('Amount is required')
    .test('is-number', 'Amount must be a valid number', (value) => !isNaN(Number(value)))
    .test('is-positive', 'Amount must be greater than 0', (value) => Number(value) > 0),
  Card: Yup.string().required('Card information is required'),
  BillingDate: Yup.mixed()
    .required('Billing date is required')
    .test('is-date', 'Invalid date', (value) => value === null || moment.isMoment(value)),
});
